import type { TimeResult } from '../calendar.types'

import { CalendarItem as YearItem, CalendarItemsContainer } from '../calendar.styles'

type YearPickerProps = {
  calendar: TimeResult
  onSelectYear?: (date: Date) => void
}

export const YearPicker = ({ calendar, onSelectYear }: YearPickerProps) => (
  <CalendarItemsContainer className="vui-year-picker">
    {calendar.items.map(item => (
      <YearItem
        fontWeight={500}
        key={item.date.getTime()}
        onClick={(!item.isDisabled && onSelectYear?.(item.date)) || undefined}
        {...item}
        alignContent="center"
        textAlign="center"
      >
        {item.date.getUTCFullYear()}
      </YearItem>
    ))}
  </CalendarItemsContainer>
)
